export default __webpack_public_path__ + "static/media/francheville15.9c0518d0.jpg";